import * as React from "react";
import {resourcesHelper} from "@falcon/services"

export default class Header extends React.Component {
    public render() {
        return (
            <React.Fragment>
                <div className="journey-bg">
                    <div>
                        <img className="waves" src="/img/Flow-waves.svg" alt="Journey background waves"/>
                        <img className="clouds" src="/img/Flow-clouds.svg" alt="Journey background clouds"/>
                    </div>
                </div>
                <div className="journey-header">
                    <div className="journey-header-background">
                        <a className="header-logo-link" id={`goTo${resourcesHelper.THEME}HomePage`} href={resourcesHelper.BRAND_URL} target="_blank" aria-label={`Link to ${resourcesHelper.THEME} home page`}>
                            <img className="flow-logo" src={`/${resourcesHelper.THEME}/img/brand-logo.png`} alt={`${resourcesHelper.THEME} logo icon`} tabIndex={0}/>
                        </a>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
